
export const setFilter = (filter) => {
    return {
        type: 'LOWERING_FILTER',
        filter,
    };
};

export const setFilterAlmox = (almox) => {
    return {
        type: 'LOWERING_FILTER_ALMOX',
        almox,
    };
};

export const selectOrderGroup = (orderGroup) => {
    return {
        type: 'LOWERING_SELECT_ORDER_GROUP',
        orderGroup,
    };
};

export const resetOrderGroup = () => {
    return {
        type: 'RESET_ORDER_GROUP'
    };
};

export const setOrders = (orders) => {
    return {
        type: 'LOWERING_ORDERS',
        orders,
    };
};

export const selectOrder = (order) => {
    return {
        type: 'LOWERING_SELECT_ORDER',
        order,
    };
};

export const selectTransmission = (transmission) => {
    return {
        type: 'SELECT_TRANSMISSION',
        transmission,
    };
};

export const selectMission = (mission) => {
    return {
        type: 'LOWERING_SELECT_MISSION',
        mission,
    };
};


export const updateMissionStatus = (orderItemId, status) => {
    return {
        type: 'UPDATE_LOWERING_MISSION_STATUS',
        orderItemId,
        status
    };
};

export const updateOrderStatus = (orderId, status) => {
    return {
        type: 'UPDATE_LOWERING_ORDER_STATUS',
        orderId,
        status
    };
};

export const resetOrder = () => {
    return {
        type: 'RESET_LOWERING_ORDER'
    };
};

export const resetOrders = () => {
    return {
        type: 'RESET_LOWERING_ORDERS'
    };
};

export const updateOrder = (order) => {
    return {
        type: 'LOWERING_UPDATE_ORDER',
        order
    };
}

export const unblockOrder = (orderId) => {
    return {
        type: 'LOWERING_UNBLOCK_ORDER',
        orderId
    };
};

export const removeOrder = (orderId, callback) => {
    return {
        type: 'LOWERING_REMOVE_ORDER',
        orderId,
        callback
    };
};

export const resetOrdesAll = () => {
    return {
        type: 'RESET_LOWERING_ORDERS',
    };
};

export const resetFilter = () => {
    return {
        type: 'RESET_LOWERING_FILTER',
    };
};

export const changeUserOrder = (orderId, newUser) => {
    return {
        type: 'LOWERING_CHANGEUSER_ORDER',
        orderId,
        newUser
    };
};

export const addOrder = (order) => {
    return {
        type: 'LOWERING_ADD_ORDER',
        order,
    };
};


export const setTransmissionsList = (transmissions) => {
    return {
        type: 'SET_TRANSMISSIONS',
        transmissions,
    };
};

export const setArea = (areas) => {
    return {
        type: 'SET_AREAS',
        areas,
    };
};

export const setSectors = (sectors) => {
    return {
        type: 'SET_SECTORS',
        sectors,
    };
};

export const setOrderReceived = (orderReceived) => {
    return {
        type: 'LOWERING_ORDER_RECEIVED',
        orderReceived,
    };
};

export const setPduLocationTargetPaged = (pduLocationTargetPaged) => {
    return {
        type: 'SET_PDU_LOCATION_TARGET_PAGED',
        pduLocationTargetPaged,
    };
};

export const setPduLocationTarget = (pduLocationTarget) => {
    return {
        type: 'SET_PDU_LOCATION_TARGET',
        pduLocationTarget,
    };
};